import  { useContext} from 'react';
import F1 from '../source/1.svg'
import { useFormik } from 'formik';
import * as Yup from 'yup';
import { FirebaseContext } from '../firebase/index';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
const Contact = () => {
    const { firebase } = useContext(FirebaseContext);


    const formik = useFormik({
        initialValues: {
            name: '',
            email: '',
            messaje: '',
        }, 
        validationSchema: Yup.object({
            name: Yup.string()
                        .min(3, 'There must be at least 3 characters in the name field')
                        .required('Name is Required'),
            email: Yup.string()
                        .email('The email is not valid')
                        .required('Email is Required'),
           messaje: Yup.string()
                        .min(10, 'The message must be longer')
                        .required('The message is required'),
                        
        }),
        onSubmit : (mensaje, actions) => {
            try {
              mensaje.creado = Date.now();

                firebase.db.collection('mensajes').add(mensaje);
                toast('🦄 Thanks for send me a message ', {
                    position: "top-right",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    });            
                    actions.resetForm();
                  
                    console.log(mensaje);
           
            } catch (error) {
               
                toast.error('😲 An ocurred an error!', {
                    position: "top-right",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    });
            }
        },        
    });
    return ( 
        <>  
            <div className="mt-3 contact">
                <div className="content">
                <ToastContainer
            position="top-right"
            autoClose={5000}
            hideProgressBar={false}
            newestOnTop={false}
            closeOnClick
            rtl={false}
            pauseOnFocusLoss
            draggable
            pauseOnHover
            />
            
            <ToastContainer />
                    <h2 className="mb-5 font-weight-bold display-4 text-center contact_text">If you liked my work you can <span className="white-text">contact me.</span>  </h2>    
                    <div className="row">
                      <div className="col-sm-6">
                            <form onSubmit={formik.handleSubmit} className="">
                                <div className="form__group field">
                                    <input type="text" className="form__field" placeholder="Your name..."  
                                        value={formik.values.name}
                                          onChange={formik.handleChange}
                                           id='name'  />
                                    <label htmlFor="name" className="form__label"> <i className="far fa-user"></i>Your name...</label> 
                              </div>
                              { formik.touched.name && formik.errors.name ? (
                                    <div className="alert alert-danger bg-danger button-text" role="alert">
                                        <p className="font-weigth-bold">An ocurred an error:</p>
                                        <strong>{formik.errors.name}</strong>
                                    </div>
                                ) : null }
                              <div className="form__group field">
                                    <input type="email" className="form__field"  
                                            value={formik.values.email}
                                            onChange={formik.handleChange}
                                           
                                             placeholder="Your Email..."  id='email'  />
                                    <label htmlFor="email" className="form__label"><i className="fas fa-at"></i> Your Email...</label> 
                              </div>
                              { formik.touched.email && formik.errors.email ? (
                                    <div className="alert alert-danger bg-danger button-text" role="alert">
                                        <p className="font-weigth-bold">An ocurred an error:</p>
                                        <strong>{formik.errors.email}</strong>
                                    </div>
                                ) : null }
                                 <div className="form__group field">
                                     <textarea   cols="30"
                                      value={formik.values.messaje}
                                      onChange={formik.handleChange}
                                      
                                       rows="3aq3"  className=" form__field mt-2" placeholder="write something..." id='messaje'></textarea>
                                    
                                     <label htmlFor="messaje" className="form__label"> <i className="far fa-envelope"></i> Message  </label> 
                                </div>

                                { formik.touched.messaje && formik.errors.messaje ? (
                                    <div className="alert alert-danger bg-danger  button-text" role="alert">
                                        <p className="font-weigth-bold">An ocurred an error:</p>
                                        <strong>{formik.errors.messaje}</strong>  
                                    </div>
                                ) : null }
                                <button type="submit" className=" btn button_contact text_contact btn-block mt-2"> <i className="far fa-paper-plane mr-2"></i>  Send me a message!</button>
                            
                             </form>
                        </div>

                        <div className="col-sm-6 d-none d-sm-block">
                           <div className="bg-image hover-overlay ripple">
                                    <img src={F1} className="img-fluid" height="50%" width="100%" alt="contact_image"/>                           
                                        <div className="mask rgba-white-slight" ></div>                         
                                </div>  
                             </div>
                        </div>    
                </div>
                 

            </div>
         </>
     );
}
 
export default Contact;
